<template>
  <ul class="tab">
    <li
      v-for="({ title, url, perm }, index) in visibleList"
      :key="index"
      @click="$router.push(url)"
      :class="{ active: $route.path == url }"
    >
      {{ title }}
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  name: 'ActivityTab',
  data() {
    return {
      list: [
        {
          title: '任务管理',
          url: '/home/activity/management',
          perm: 'tenant:activity_task_mgmt:tab_management',
        },
        {
          title: '任务类型管理',
          url: '/home/activity/typeManagement',
          perm: 'tenant:activity_task_mgmt:tab_type_management',
        },
        // { title: '黑名单管理', url: '/home/activity/blocklistManagement' },
        {
          title: '用户类型管理',
          url: '/home/activity/userTypeManagement',
          perm: 'tenant:activity_task_mgmt:tab_user_type_management',
        },
      ],
    }
  },

  methods: {},
  computed: {
    visibleList() {
      return this.list.filter((item) => this.$hasPerm(item.perm))
    },
  },
}
</script>

<style lang="less" scoped>
.tab {
  display: flex;
  list-style: none;
  gap: 16px;
  padding: 0;
  li {
    cursor: pointer;
    &:hover {
      color: #707aff;
    }
  }
  .active {
    color: #707aff;
  }
}
</style>
